import { Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { Snackbars as AlchemySnackbars } from 'common/components/alchemy/Snackbars/Snackbars';
import { Feedback } from 'common/components/cookbook/Feedback/Feedback';
import { PageSpinner } from 'common/components/cookbook/PageSpinner';
import { Snackbars as CookbookSnackbars } from 'common/components/cookbook/Snackbars/Snackbars';
import { Toasts } from 'common/components/cookbook/Toasts/Toasts';

import { UpdateNotification } from '../UpdateNotification';

const RouterDevtools =
  import.meta.env.VITE_DEV_TOOLS_ENABLED === 'true'
    ? lazy(() =>
        import('@tanstack/router-devtools')
          .then((m) => ({
            default: m.TanStackRouterDevtools,
          }))
          .catch((_err) => {
            console.error('Could not load router devtools');
            return { default: () => null };
          }),
      )
    : () => null;

export const RootLayout = () => {
  return (
    <>
      <Suspense fallback={null}>
        <RouterDevtools position="bottom-right" />
      </Suspense>
      <Toasts />
      <CookbookSnackbars />
      <AlchemySnackbars />
      <Feedback />
      <UpdateNotification />
      <Suspense fallback={<PageSpinner />}>
        <Outlet />
      </Suspense>
    </>
  );
};
